import type { DealerSummary } from "./dealer";

export type EmployeeRole = "GENERAL_MANAGER" | "SALES_REPRESENTATIVE";

export type EmployeeStatus = "ACTIVE" | "ADDED_BY_DEALER" | "DELETED_BY_DEALER";

export interface Employee {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  role: EmployeeRole;
  status: EmployeeStatus;
  title: string;
  birthday?: string;
  profile_notes?: string;
  gift_sent?: boolean;
  last_activity?: string;
  additional_emails?: string[];
  dealer: DealerSummary;
  created_at: string;
  updated_at: string;
}

export interface EmployeeSummary {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  role: EmployeeRole;
  status: EmployeeStatus;
  title: string;
  birthday?: string;
}

const employeeRoleLabels: Record<EmployeeRole, string> = {
  GENERAL_MANAGER: "General Manager",
  SALES_REPRESENTATIVE: "Sales Representative",
};

const employeeStatusLabels: Record<EmployeeStatus, string> = {
  ACTIVE: "Active",
  ADDED_BY_DEALER: "Added by Dealer",
  DELETED_BY_DEALER: "Deleted by Dealer",
};

export const formatEmployeeRole = (role: string | undefined): string => {
  if (!role) return "";

  const upperRole = role.toUpperCase() as EmployeeRole;
  return employeeRoleLabels[upperRole] || role;
};

export const formatEmployeeStatus = (status: string | undefined): string => {
  if (!status) return "";

  const upperStatus = status.toUpperCase() as EmployeeStatus;
  return employeeStatusLabels[upperStatus] || status;
};

export const getEmployeeRoleOptions = () => {
  return Object.entries(employeeRoleLabels).map(([value, label]) => ({
    value,
    label,
  }));
};

export const getEmployeeStatusOptions = () => {
  return Object.entries(employeeStatusLabels).map(([value, label]) => ({
    value,
    label,
  }));
};
